import React, {useState, useEffect} from 'react';
import PurchaseOrderDetails from '../../components/purchaseOrders/purchaseOrder/PurchaseOrderDetails';
import PurchaseOrderDetailsNew from '../../components/purchaseOrders/purchaseOrder/PurchaseOrderDetailsNew';
// import PurchaseOrderLinks from '../components/purchaseOrders/purchaseOrder/PurchaseOrderLinks';
import {quadralSwal} from '@quadral/quadral-component-common/dist/components/swal';
import QuadralToast, {quadralToast} from '@quadral/quadral-component-common/dist/components/toast';
import QuadralContainer from "@quadral/quadral-component-common/dist/components/container";
import {purchaseOrdersService, userService} from "../../services";
import {useLoader} from "@quadral/quadral-component-common/dist/components/loader/LoaderContext";

const PurchaseOrder = (props) => {
    const [purchaseOrder, setPurchaseOrder] = useState(null);
    const {showLoader, hideLoader} = useLoader();
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        status: '',
        expectedCompletionDate: null,
        expectedVisitDate: null,
        customerComment: '',
        applicant: {id: '', name: ''}
    });
    const [diagnosticsFormData, setDiagnosticsFormData] = useState([]);
    const [initialDiagnostics, setInitialDiagnostics] = useState([]);
    const [valueApplicant, setValueApplicant] = useState("");
    const [resultApplicant, setResultApplicant] = useState([]);
    const [canUpdate, setCanUpdate] = useState(false);
    const [canCancelOrder, setCanCancelOrder] = useState(false);

    // const handleExecutionModeChange = (index, value, item) => {
    //     const updatedExecutionModes = diagnosticsFormData.map(diag =>
    //         diag.id === item.id
    //             ? {...diag, executionMode: value}
    //             : diag
    //     );
    //     setDiagnosticsFormData(updatedExecutionModes)
    // };

    const handleField = (fieldName, value) => {
        if (fieldName === 'applicant') {
            setFormData({
                ...formData,
                [fieldName]: {
                    id: value.id,
                    name: value.name
                }
            })
        } else {
            setFormData({
                ...formData,
                [fieldName]: value,
            });
        }
    };

    // TODO Utiliser une modal et supprimer cet import (swal)
    function confirmation(purchaseOrder) {
        quadralSwal.warning({
            title: "Confirmation",
            text: "Cette action va annuler la commande, êtes vous sûr(e) ?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Oui, annuler',
            cancelButtonText: 'Non',
            reverseButtons: true,
            customClass: {
                confirmButton: 'btn details-button btn-primary',
                cancelButton: 'btn details-button btn-secondary'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                cancel(purchaseOrder);
            }
        })
    };

    function applicantAutocomplete(applicant) {
        purchaseOrdersService.findAutocompleteContact(applicant)
            .then(data => {
                setResultApplicant(data);
            })
            .catch(err => {
                console.error(err);
            });
    }

    function cancel(purchaseOrder) {
        purchaseOrdersService.cancelPurchaseOrder(purchaseOrder?.id)
            .then(() => {
                refreshOrder(purchaseOrder?.id);
                return purchaseOrdersService.findPurchaseOrderById(purchaseOrder?.id)
            }).then((updatedOrder) => {
            if (updatedOrder.status === 'Annulée') {
                quadralToast.success('Commande annulée avec succès');
            } else {
                quadralToast.error('La commande n\'a pas pu être annulée');
            }
        })
            .catch(err => {
                console.error(err);
                quadralToast.error("Une erreur est survenue pendant l'annulation de la commande")
            });
    }

    function save() {
        showLoader();

        purchaseOrdersService.updatePurchaseOrdersById(purchaseOrder.id, formData)
            .then(response => {
                hideLoader()
            })
            .catch(error => hideLoader())

        const updateDiagnosticPromises = diagnosticsFormData.map(diagnostic => {
            const initialDiagnostic = initialDiagnostics.find(initialDiag => initialDiag.id === diagnostic.id);

            if (initialDiagnostic && initialDiagnostic.executionMode !== diagnostic.executionMode) {
                return purchaseOrdersService.updatePurchaseOrdersDiagnosticById(diagnostic.id, diagnostic)
                    .catch(error => {
                        quadralToast.error('Le mode d\'exécution n\'a pas été mis à jour. Veuillez réessayer.');
                    });
            } else {
                return Promise.resolve();
            }
        });

        Promise.all(updateDiagnosticPromises)
            .then(() => {
                setIsEditing(false);
            })
            .catch(error => hideLoader());
    }

    function validate() {
        showLoader();

        const updatedPurchaseOrderStatus = {...purchaseOrder, status: 'En cours'}
        let data = formData;
        data.status = 'En cours';

        purchaseOrdersService.updatePurchaseOrdersById(purchaseOrder.id, data)
            .then(response => {
                setPurchaseOrder(updatedPurchaseOrderStatus);
                quadralToast.success('La commande est en cours d’envoi au(x) diagnostiqueur(s). L’opération peut prendre quelques minutes.', {
                    onClose: () => window.location.reload()
                });
                hideLoader()
            })
            .catch(error => {
                quadralToast.error('Votre commande n’a pas pu être envoyée, veuillez contacter l’assistance.');
                hideLoader()
            })
    }

    function parseDate(dateToParse) {
        const options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
        }
        return dateToParse ? new Date(dateToParse).toLocaleDateString(undefined, options) : '';
    }

    // function linkToRealEstate(realEstateType, realEstateRef) {
    //     return props.configuration?.realEstateUrl + "?" + realEstateType + "=" + realEstateRef;
    // }

    useEffect(() => {
        applicantAutocomplete(valueApplicant);
    }, [valueApplicant]);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const purchaseOrderId = urlParams.get('id');

        if (purchaseOrderId) {
            refreshOrder(purchaseOrderId);
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    function refreshOrder(purchaseOrderId) {
        showLoader();
        purchaseOrdersService.findPurchaseOrderById(purchaseOrderId)
            .then(data => {
                setPurchaseOrder(data);
                setFormData({
                    status: data.status,
                    expectedCompletionDate: data.expectedCompletionDate || null,
                    expectedVisitDate: data.expectedVisitDate || null,
                    customerComment: data.customerComment || '',
                    additionalInformations: data.additionalInformations || '',
                    applicant: {id: data.applicant?.id || '', name: data.applicant?.name || ''}
                })

                let diagnostics = [];

                const extractDiagnostics = (items) => {
                    items.forEach(item => {
                        if (item.diagnostics) {
                            item.diagnostics = item.diagnostics.filter(diagnostic => diagnostic.status !== 'Annulé');
                            diagnostics.push(
                                ...item.diagnostics.map(diagnostic => ({
                                    id: diagnostic.id,
                                    executionMode: diagnostic.executionMode
                                }))
                            );
                        }
                        if (item.entrances) {
                            extractDiagnostics(item.entrances);
                        }
                        if (item.modules) {
                            extractDiagnostics(item.modules);
                        }
                    });
                };

                if (data.buildings) {
                    extractDiagnostics(data.buildings);
                }

                setDiagnosticsFormData(diagnostics);
                setInitialDiagnostics(diagnostics);
                hideLoader();
            })
            .catch(error => {
                hideLoader();
            });
    }

    useEffect(() => {
        userService.hasRole('purchase-order.write').then(hasRole => setCanUpdate(hasRole));
    }, []);

    useEffect(() => {
        setCanCancelOrder(hasValidatedReport(purchaseOrder) && hasStatus(purchaseOrder) && canUpdate)
    }, [purchaseOrder]) // eslint-disable-line react-hooks/exhaustive-deps

    function hasValidatedReport(purchaseOrder) {
        if (purchaseOrder?.buildings) {
            for (const building of purchaseOrder.buildings) {
                if (building.diagnostics?.some(d => d.status === "Rapport validé")) {
                    return false;
                }
                if (building.entrances) {
                    for (const entrance of building.entrances) {
                        if (entrance.diagnostics?.some(d => d.status === "Rapport validé")) {
                            return false;
                        }
                        if (entrance.modules) {
                            for (const module of entrance.modules) {
                                if (module.diagnostics?.some(d => d.status === "Rapport validé")) {
                                    return false;
                                }
                            }
                        }
                    }
                }
            }
        }
        return true;
    }

    function hasStatus(purchaseOrder) {
        if (purchaseOrder?.status) {
            if (purchaseOrder?.status === "Brouillon" ||
                purchaseOrder?.status === "Nouvelle" ||
                purchaseOrder?.status === "En attente infos" ||
                purchaseOrder?.status === "En cours") {
                return true;
            }
        }
        return false;
    }

    return (
        <>
            <QuadralToast/>
            <h1>Bon de
                commande {purchaseOrder?.orderNumber} du {parseDate(purchaseOrder?.effectiveDate)}</h1>
            <form action="">
                <QuadralContainer className='container-fluid container-view'>
                    {purchaseOrder?.status === "Nouvelle" ? (
                        <PurchaseOrderDetailsNew purchaseOrder={purchaseOrder}
                                                 isEditing={isEditing}
                                                 setIsEditing={setIsEditing}
                                                 formData={formData}
                                                 confirmation={confirmation}
                                                 setFormData={setFormData}
                                                 showLoader={showLoader}
                                                 hideLoader={hideLoader}
                                                 save={save}
                                                 diagnosticsFormData={diagnosticsFormData}
                                                 canCancelOrder={canCancelOrder}
                                                 setDiagnosticsFormData={setDiagnosticsFormData}
                                                 validate={validate}
                                                 handleField={handleField}
                                                 resultApplicant={resultApplicant}
                                                 canUpdate={canUpdate}
                                                 setCanUpdate={setCanUpdate}
                                                 cancelOrder={cancel}
                                                 valueApplicant={valueApplicant}
                                                 setValueApplicant={setValueApplicant}
                        />
                    ) : (
                        <PurchaseOrderDetails purchaseOrder={purchaseOrder}
                                              config={props.configuration}
                                              isEditing={isEditing}
                                              setIsEditing={setIsEditing}
                                              formData={formData}
                                              cancelOrder={cancel}
                                              confirmation={confirmation}
                                              setFormData={setFormData}
                                              save={save}
                                              handleField={handleField}
                                              canCancelOrder={canCancelOrder}
                                              resultApplicant={resultApplicant}
                                              canUpdate={canUpdate}
                                              setCanUpdate={setCanUpdate}
                                              valueApplicant={valueApplicant}
                                              setValueApplicant={setValueApplicant}
                        />
                    )}
                </QuadralContainer>
                {/*<PurchaseOrderLinks purchaseOrder={purchaseOrder}*/}
                {/*                    setPurchaseOrder={setPurchaseOrder}*/}
                {/*                    showLoader={showLoader}
                                       hideLoader={hideLoader}*/}
                {/*                    isEditing={isEditing}*/}
                {/*                    setIsEditing={setIsEditing}*/}
                {/*                    formData={formData}*/}
                {/*                    setFormData={setFormData}*/}
                {/*                    handleExecutionModeChange={handleExecutionModeChange}*/}
                {/*                    refreshOrder={refreshOrder}*/}
                {/*                    diagnosticsFormData={diagnosticsFormData}*/}
                {/*                    canUpdate={canUpdate}*/}
                {/*                    setDiagnosticsFormData={setDiagnosticsFormData}*/}
                {/*                    config={props.configuration}*/}
                {/*                    linkToRealEstate={linkToRealEstate}*/}
                {/*/>*/}
            </form>
        </>
    );
};

export default PurchaseOrder;